import * as React from 'react';
import { tss } from 'tss-react/mui';
import { Link } from 'react-router';
import type { NamedColors } from '@/theme';
import { ArrowLeftIcon } from '../icons';
import Button from '../Button';

const useBackButtonStyles = tss
    .withParams<{ color: NamedColors }>()
    .withNestedSelectors<'disabled'>()
    .create(({ theme, classes, color }) => ({
        root: {
            borderBottom: `solid 1px ${theme.bino.color.lightGray}`,
            padding: '0 24px 0 20px',
            display: 'flex',
            alignItems: 'center',
            height: 54,

            [`&:hover:not(.${classes.disabled}) *`]: {
                color: theme.palette.primary.main,
            },
        },
        rootInline: {
            display: 'inline',
            height: 'auto',
            padding: 0,
            borderBottom: 0,

            [`&:hover:not(.${classes.disabled}) *`]: {
                color: theme.palette.primary.main,
            },
        },
        disabled: {
            opacity: 0.5,
            cursor: 'not-allowed',
        },
        icon: {
            color: theme.bino.color[color],
            marginRight: 16,
            marginTop: -2,
        },
        button: {
            color: theme.bino.color[color],
        },
    }));

type BackButtonProps = {
    color?: NamedColors;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    to?: string;
    disabled?: boolean;
    className?: string;
    variant?: 'default' | 'inline';
    children: React.ReactNode;
};

const BackButton: React.FunctionComponent<BackButtonProps> = ({
    color = 'gray',
    disabled = false,
    onClick,
    to,
    variant = 'default',
    className,
    children,
}) => {
    const { classes, cx } = useBackButtonStyles({ color });

    const rootClassName = React.useMemo(() => {
        switch (variant) {
            case 'inline': {
                return classes.rootInline;
            }
            default: {
                return classes.root;
            }
        }
    }, [classes, variant]);

    return (
        <div
            className={cx(
                rootClassName,
                className,
                disabled ? classes.disabled : undefined,
            )}
        >
            <Button
                to={to}
                component={to ? Link : undefined}
                onClick={onClick}
                variant="text"
                disabled={disabled}
                className={classes.button}
            >
                <ArrowLeftIcon
                    data-testid="left-icon"
                    size={12}
                    className={classes.icon}
                />
                {children}
            </Button>
            {/*{!disabled && (*/}
            {/*    <Component*/}
            {/*        {...buttonProps}*/}
            {/*    >*/}
            {/*        <ArrowLeftIcon*/}
            {/*            data-testid="left-icon"*/}
            {/*            size={12}*/}
            {/*            className={classes.icon}*/}
            {/*        />*/}
            {/*        {children}*/}
            {/*    </Component>*/}
            {/*)}*/}
            {/*{disabled && <span className={classes.link}>{children}</span>}*/}
        </div>
    );
};

export default BackButton;
